import dayjs from 'dayjs';
import { get } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import LandingPageContainer from 'containers/LandingPageContainer';
import Log from 'utils/Log';

const LandingPageController = class {
  static get windowData() {
    const data = get(window, ['ALLBIRDS', 'landingPage']);

    if (!data) {
      Log.error(new Error('Controllers:LandingPageController.windowData -- missing window data!'));
    }

    return data;
  }

  static get scheduledDropDatetime() {
    return get(LandingPageController.windowData, 'scheduledDropDatetime');
  }

  static get hasCountdownTimer() {
    const future = dayjs(LandingPageController.scheduledDropDatetime);

    // is that you, Dad?
    if (!future) {
      return false;
    }

    const now = dayjs();

    return now.isBefore(future);
  }

  static mountLandingPageContainer = store => {
    ReactDOM.render(
      <Provider store={store}>
        <LandingPageContainer
          data={LandingPageController.windowData}
          hasCountdownTimer={LandingPageController.hasCountdownTimer}
        />
      </Provider>,
      document.getElementById('landing-page-container')
    );
  };

  static init = store => {
    LandingPageController.mountLandingPageContainer(store);
  };
};

export default LandingPageController;
